import { makeStyles } from '@material-ui/core/styles';

export const useTrackingStyles = makeStyles(() => ({
  loading: {
    display: 'flex',
    justifyContent: 'center',
  },
  loadingImage: {
    height: 72,
    width: 72,
  },
  underProduct: {
    marginTop: 20,
  },
  divider: {
    margin: '0 -16px',
  },
}));

export const useTrackingContainerStyles = makeStyles(() => ({
  closeButton: {
    fontSize: '40px',
    cursor: 'pointer',
  },
}));

export const useEmptyStateStyles = makeStyles(() => ({
  image: {
    height: 164,
    width: 151,
  },
}));

export const useColorLibConnectorStyles = makeStyles((theme) => ({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  activeFailed: {
    '& $line': {
      backgroundColor: '#FFCC00',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  completedFailed: {
    '& $line': {
      backgroundColor: '#FFCC00',
    },
  },
  vertical: {
    '& $line': {
      width: 3,
      marginLeft: 10,
      marginBottom: '-10px',
      height: 30,
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#bcbcbc',
    borderRadius: 1,
  },
}));

const borderForcolorlibStepIcon = (props, theme) =>
  props.failed
    ? '2px solid #FFCC00'
    : `2px solid ${theme.palette.primary.main}`;

export const useColorlibStepIconStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#bcbcbc',
    zIndex: 1,
    width: 48,
    height: 48,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  active: {
    backgroundColor: (props) =>
      props.failed ? '#FFCC00' : theme.palette.primary.main,
    border: (props) => borderForcolorlibStepIcon(props, theme),
  },
  completed: {
    backgroundColor: 'white',
    border: (props) => borderForcolorlibStepIcon(props, theme),
  },
}));

export const useTrackingStepperStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  label: {
    '& .MuiTypography-body2': {
      fontSize: 14,
    },
  },
}));
